import * as React from 'react';
const Diff = require('diff');

interface IArticleImproveProps {
    previousDraft: string;
    newDraft: string;
}

export default function ArticleImprove(props: IArticleImproveProps) {

    const [renderContent, setRenderContent] = React.useState<string>('')

    React.useEffect(()=> {
        setRenderContent(htmlDiff(props.previousDraft, props.newDraft))
    }, [props.previousDraft, props.newDraft])

    return (
        <div dangerouslySetInnerHTML={{ __html: renderContent }}></div>
    )
}

const htmlDiff = (previousHTML: string, currentHTML: string ) => {
    let isAnchorAdded = false
    if(previousHTML === currentHTML) {
        return previousHTML
    }
    // parse HTML string tp DOM node
    const parseHtml = (htmlStr: string) => {
        const parser = new DOMParser();
        return parser.parseFromString(htmlStr, 'text/html').body;
    };

    const diffNodes = (previousNode, currentNode) => {
        // if is text node，use diff compare
        if (previousNode.nodeType === Node.TEXT_NODE && currentNode.nodeType === Node.TEXT_NODE) {
            const diff = Diff.diffChars(previousNode.nodeValue, currentNode.nodeValue);
            return diff.map((part) => {
                const backgroundColor = part.added ? 'lightGreen' : part.removed ? '#fadad7' : 'transparent';
                const lineThrough = part.removed ? 'text-decoration: line-through; color: #b30000' : '';
                let needAddAnchor = false;
                if((part.added || part.removed) && !isAnchorAdded) {
                    needAddAnchor = true;
                    isAnchorAdded = true;
                }
                return `<span ${ needAddAnchor? 'id="first-anchor"': ''} style="background: ${backgroundColor}; ${lineThrough}">${part.value}</span>`;
            }).join('');
        }

        // compare tag and property(style...)
        if (previousNode.tagName === currentNode.tagName) {
            const attrDiff = [];
            const styleA = previousNode.getAttribute('style') || '';
            const styleB = currentNode.getAttribute('style') || '';

            // if style is different, highlight it
            if (styleA !== styleB) {
                attrDiff.push(`border-top: 2px solid lightBlue;border-bottom: 2px solid lightBlue;${styleB}`);
            }

            // recursively compare child nodes
            const childrenA = Array.from(previousNode.childNodes);
            const childrenB = Array.from(currentNode.childNodes);
            const maxLength = Math.max(childrenA.length, childrenB.length);

            let childrenDiff = '';
            for (let i = 0; i < maxLength; i++) {
                const childA = childrenA[i] || document.createTextNode('');
                const childB = childrenB[i] || document.createTextNode('');
                childrenDiff += diffNodes(childA, childB);
            }

            let needAddAnchor = false;
            if(!isAnchorAdded && attrDiff.length > 0) {
                needAddAnchor = true;
                isAnchorAdded = true;
            }

            return `<${previousNode.tagName.toLowerCase()} ${ needAddAnchor? 'id="first-anchor"': ''} style="${attrDiff.join(' ')}">${childrenDiff}</${previousNode.tagName.toLowerCase()}>`;
        }

        return `<span style="background: lightGreen;">${currentNode.outerHTML}</span>`;
    };

    const previousNode = parseHtml(previousHTML);
    const currentNode = parseHtml(currentHTML);

    const htmlStr = diffNodes(previousNode, currentNode);
    
    return htmlStr;
};